import Gravity from 'Gravity';

const returnEquityForm = () => {
    if (!document.querySelector('.gg-return-on-equity-form')) {
        return;
    }

    const cookieName = 'form_gated_send_successfully'
    const cookieValue = Gravity.getCookie(cookieName);

    const equityForm = document.querySelector('.gg-return-on-equity-form');
    const gatedArticles = document.querySelectorAll('.gg-gated-article');
    const bannerOpenContent = document.querySelectorAll('.gg-gated .gg-article-banner-v1');
    const bannerWithForm = document.querySelectorAll('.gg-gated .gg-text-banner');
    const bannerWithFormv2 = document.querySelectorAll('.gg-gated .gg-article-banner-v2');

    const shouldShowGatedContent = cookieValue === 'true' || document.cookie.includes(cookieName);

    if (shouldShowGatedContent) {
        // eslint-disable-next-line no-restricted-syntax
        for (const article of gatedArticles) {
            article.classList.add('gg-gated-article__open');
        }
        equityForm.classList.add('gg-return-on-equity-form__hide');
        bannerOpenContent.forEach(element => {
            element.classList.add('gg-open-content-banner-show');
        });
        bannerWithForm.forEach(element => {
            element.classList.add('gg-open-content-banner-hide');
        });
        bannerWithFormv2.forEach(element => {
            element.classList.add('gg-open-content-banner-hide');
        });
    }

    /* eslint-disable */
    jQuery(document).ready(() => {
        jQuery(document).on('gform_confirmation_loaded', (_e, formID) => {
            const confirmationWrapper = document.querySelector(`#gform_confirmation_wrapper_${formID}`);
            const equityFormContainer = confirmationWrapper.closest('.gg-return-on-equity-form');

            equityFormContainer.classList.add('gg-return-on-equity-form__successful');

            const elementsToTrigger = document.querySelectorAll('.trigger-popup');
            elementsToTrigger.forEach(element => {
                element.dispatchEvent(new Event('click'));
            });
            const popUpButton = document.querySelector('.gg-gated-popup__button');

            Gravity.clickEnterListener(popUpButton, () => {
                // eslint-disable-next-line no-restricted-syntax
                for (const article of gatedArticles) {
                    article.classList.add('gg-gated-article__open');
                }
                equityForm.classList.add('gg-return-on-equity-form__hide');
                bannerOpenContent.forEach(element => {
                    element.classList.add('gg-open-content-banner-show');
                });
                bannerWithForm.forEach(element => {
                    element.classList.add('gg-open-content-banner-hide');
                });

                bannerWithFormv2.forEach(element => {
                    element.classList.add('gg-open-content-banner-hide');
                });

                document.cookie = `${cookieName}=true; path=/`;

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        });
    });
    /* eslint-enable */
};

Gravity.ready(returnEquityForm);
